import { Box, Typography, useMediaQuery } from "@mui/material";

const ViewMessage = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: isMobile ? "16px" : "",
      }}
    >
      <Typography sx={{ fontWeight: 700 }}>
        This site is best viewed in Apple Safari, Google Chrome and Microsoft
        Edge browsers
      </Typography>
    </Box>
  );
};

export default ViewMessage;
